export default "__VITE_ASSET__b0ee542b__"